import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import config from '../../config';
import { v4 as uuidv4 } from 'uuid';
// import { carrierOptions } from '../../utils/DropDownOptions';

const getCarrierOptionsByCaseId = (caseId) => {
    const storedData = localStorage.getItem('carrierNames');
    if (storedData) {
        const carrierNamesMap = JSON.parse(storedData);
        return (carrierNamesMap[caseId] || []).map(carrier => ({ value: carrier, label: carrier }));
    }
    return [];
};

function EnrollmentContacts({ caseId, renewalCase, isDisableForUsers, onError = () => { } }) {
    const fetchUrl = `${config.API_URL}/EnrollmentAndEligibilityContacts/ByCaseId/${caseId}`;
    const updateUrl = `${config.API_URL}/EnrollmentAndEligibilityContacts`;

    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [showForm, setShowForm] = useState(false);
    const [editingContactId, setEditingContactId] = useState(null);
    const [contactType, setContactType] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [carrier, setCarrier] = useState('All');
    const [benefitType, setBenefitType] = useState('All');
    const [selectedCarrier, setSelectedCarrier] = useState([]);
    const [selectedBenefitType, setSelectedBenefitType] = useState([]);

    useEffect(() => {
        fetchContacts();
    }, []);

    const fetchContacts = async () => {
        try {
            const response = await axios.get(fetchUrl);
            setContacts(response.data || []);
        } catch (error) {
            setError('Error fetching contacts.');
            onError(error);
        } finally {
            setLoading(false);
        }
    };

    const validateForm = () => {
        if (!contactType) {
            alert('Please select a contact type.');
            return false;
        }
        if (!name.trim()) {
            alert('Please enter a name.');
            return false;
        }
        if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            alert('Please enter a valid email address.');
            return false;
        }
        if (carrier === 'Specify Carriers' && selectedCarrier.length === 0) {
            alert('Please specify a carrier.');
            return false;
        }
        if (benefitType === 'Specify Benefit Types' && selectedBenefitType.length === 0) {
            alert('Please specify a benefit type.');
            return false;
        }
        return true;
    };

    const handleSaveContact = async () => {
        if (!validateForm()) return;
        let carrierNameToSave = '';
        const contactDescription = `${contactType === 'Broker' ? 'BR' : contactType === 'Employer' ? 'ER' : contactType === 'Carrier' ? 'CR' :''}: ${name}`;
        if (carrier === 'All') {
            carrierNameToSave = 'All';
        } else if (carrier === 'Specify Carriers' && selectedCarrier.length > 0) {

            carrierNameToSave = selectedCarrier.join(',');  // Save selected carriers as comma-separated values
        }

        const updatedFields = {
            contactDescription,
            contactEmail: email,
            carrierType: carrier,
            carrierName: carrierNameToSave,
            //carrierType: carrier === 'Specify Carriers' ? selectedCarrier.join(',') : carrier,
            benefitType: benefitType === 'Specify Benefit Types' ? selectedBenefitType.join(',') : benefitType
        };

        const fieldsToPatch = Object.entries(updatedFields).reduce((acc, [key, value]) => {
            if (value !== undefined && value !== '') {
                acc.push({ path: `/${key}`, value });
            }
            return acc;
        }, []);

        if (fieldsToPatch.length === 0) {
            alert('No changes detected.');
            return;
        }

        try {
            await axios.patch(`${updateUrl}/${editingContactId}`, fieldsToPatch);
            setContacts(contacts.map(contact =>
                contact.contactId === editingContactId ? { ...contact, ...updatedFields } : contact
            ));
            setShowForm(false);
            resetForm();
        } catch (error) {
            setError('Error updating contact.');
            console.error('Error updating contact:', error.response ? error.response.data : error.message);
            onError(error);
        }
    };

    const handleEditContact = (contact) => {
        if (!contact || !contact.contactDescription) {
            console.error('Invalid contact data');
            return;
        }

        const contactTypeFromDescription = contact.contactDescription.includes('BR') ? 'Broker' :
            contact.contactDescription.includes('ER') ? 'Employer' :
                contact.contactDescription.includes('CR') ? 'Carrier' :
                    '';

        const carrierType = (contact.carrierName?.length > 0 && contact.carrierType !== 'All') ? 'Specify Carriers' : 'All';

        setEditingContactId(contact.contactId);
        setContactType(contactTypeFromDescription);
        setName(contact.contactDescription.split(': ')[1] || '');
        setEmail(contact.contactEmail || '');
        setCarrier(carrierType); // Set to "Specify Carriers" if there are carrier names
        setBenefitType(contact.benefitType || 'All Benefit Types');
        setSelectedCarrier(contact.carrierName?.length > 0 ? contact.carrierName.split(',') : []); // Use carrierName for multi-select
        setSelectedBenefitType(contact.benefitType === 'Specify Benefit Types' ? contact.benefitType.split(',') : []);
        setShowForm(true);
    };


    const handleAddContact = async () => {
        if (!validateForm()) return;

        let carrierNameToSave = '';
        const contactDescription = `${contactType === 'Broker' ? 'BR' : contactType === 'Employer' ? 'ER' : contactType === 'Carrier' ? 'CR' :''}: ${name}`;

        if (carrier === 'All') {
            carrierNameToSave = '';
        } else if (carrier === 'Specify Carriers' && selectedCarrier.length > 0) {

            carrierNameToSave = selectedCarrier.join(',');
        }



        const randomId = uuidv4();
        const randomContactId = uuidv4();
        const newContact = {
            caseContactId: randomId,
            contactId: randomContactId,
            contactType:contactType,
            contactDescription,
            contactEmail: email,
            carrierType: carrier,
            carrierName: carrierNameToSave,
            benefitType: benefitType === 'Specify Benefit Types' ? selectedBenefitType.join(',') : benefitType,
            contactStatus: 'Active',
            caseId: caseId
        };

        try {
            await axios.post(updateUrl, newContact);
            setContacts([...contacts, newContact]);
            setShowForm(false);
            resetForm();
        } catch (error) {
            setError('Error adding contact.');
            console.error('Error adding contact:', error);
            onError(error);
        }
    };

    const handleToggleChange = async (e, _id) => {
        const { checked } = e.target;

        const updatedContact = {
            contactStatus: checked ? 'Active' : 'Inactive',
        };

        try {
            const patchDocument = Object.keys(updatedContact).map(key => ({
                path: `/${key}`,
                value: updatedContact[key]
            }));
            await axios.patch(`${updateUrl}/${_id}`, patchDocument);
            setContacts(contacts.map(contact =>
                contact.contactId === _id ? { ...contact, contactStatus: updatedContact.contactStatus } : contact
            ));
        } catch (error) {
            setError('Error updating contact status.');
            console.error('Error updating contact status:', error.response ? error.response.data : error.message);
            onError(error);
        }
    };

    const handleCancel = () => {
        setShowForm(false);
        resetForm();
        setEditingContactId(null);
    };

    const resetForm = () => {
        setEditingContactId(null);
        setContactType('');
        setName('');
        setEmail('');
        setCarrier('All');
        setBenefitType('All');
        setSelectedCarrier([]);
        setSelectedBenefitType([]);
    };

    const getContactDescription = () => {
        return `${contactType === 'Broker' ? 'BR' : contactType === 'Employer' ? 'ER' : contactType === 'Carrier' ? 'CR' :''}: ${name}`;
    };

    const carrierOptions = getCarrierOptionsByCaseId(caseId);

    //const isDisabled = renewalCase?.directBillSubmissionStatus === 'Submitted' || isDisableForUsers;
    const isDisabled = isDisableForUsers;


    return (
        <div className="col-lg-12 mb-3">
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <h6 className="card-title">Enrollment and Eligibility Contacts</h6>
                    </div>
                    <div className="d-flex mb-2 open_enrollment">
                                <em >Below is what we have listed as your enrollment and eligibility contacts. If this information is accurate you can skip to the next section. If you need to change or add a contact, please do so here.</em>
                            </div>
                    <div className="row shadow-none p-3 mb-5 bg-light rounded">
                        <div className="d-flex justify-content-end mb-3">
                            {!showForm && (
                                <button
                                    className="btn btn-success btn-sm mt-1 me-1" disabled={isDisabled}
                                    onClick={() => setShowForm(true)}
                                >
                                    Add New Contact
                                </button>
                            )}
                        </div>

                        {showForm && (
                            <div className="container mb-4">
                                <form>
                                    <div className='row'>
                                        <div className="col-lg-4 mb-3">
                                            <label htmlFor="contactType" className="form-label">Contact Type</label>
                                            <select
                                                id="contactType"
                                                className={`form-control ${editingContactId ? 'read-only' : ''}`}
                                                value={contactType}
                                                onChange={(e) => setContactType(e.target.value)}
                                                disabled={!!editingContactId}
                                            >
                                                <option value="">Select Contact Type</option>
                                                <option value="Broker">Broker</option>
                                                <option value="Employer">Employer</option>
                                                <option value="Carrier">Carrier</option>
                                            </select>
                                        </div>

                                        <div className="col-lg-4 mb-3">
                                            <label htmlFor="name" className="form-label">Name</label>
                                            <input
                                                type="text"
                                                id="name"
                                                className={`form-control ${editingContactId ? 'read-only' : ''}`}
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                readOnly={!!editingContactId} // Read-only when editing
                                            />
                                        </div>

                                        <div className="col-lg-4 mb-3">
                                            <label htmlFor="email" className="form-label">Email</label>
                                            <input
                                                type="email"
                                                id="email"
                                                className={`form-control ${editingContactId ? 'read-only' : ''}`}
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                readOnly={!!editingContactId} // Read-only when editing
                                            />
                                        </div>

                                        <div className="col-lg-4 mb-3">
                                            <label htmlFor="description" className="form-label">Description</label>
                                            <input
                                                type="text"
                                                id="description"
                                                className="form-control read-only"
                                                value={getContactDescription()}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-lg-4 mb-3">
                                            <label htmlFor="carrier" className="form-label">Carrier</label>
                                            <Select
                                                id="carrier"
                                                value={{ value: carrier, label: carrier }}
                                                onChange={(selectedOption) => setCarrier(selectedOption.value)}
                                                options={[
                                                    { value: 'All', label: 'All Carriers' },
                                                    { value: 'Specify Carriers', label: 'Specify Carriers' },
                                                ]}
                                            />

                                            {carrier === 'Specify Carriers' && (
                                                <div className="mt-2">
                                                    <Select
                                                        isMulti
                                                        value={selectedCarrier.map(carrier => ({ value: carrier, label: carrier }))}
                                                        onChange={(selectedOptions) =>
                                                            setSelectedCarrier(selectedOptions.map(option => option.value)) // Capture updated carriers
                                                        }
                                                        options={carrierOptions}
                                                    />
                                                </div>
                                            )}
                                        </div>



                                        <div className="col-lg-4 mb-3">
                                            <label htmlFor="benefitType" className="form-label">Benefit Types</label>
                                            <Select
                                                id="benefitType"
                                                value={{ value: benefitType, label: benefitType }}
                                                onChange={(selectedOption) => setBenefitType(selectedOption.value)}
                                                options={[
                                                    { value: 'All Benefit Types', label: 'All Benefit Types' },
                                                    { value: 'Specify Benefit Types', label: 'Specify Benefit Types' },
                                                ]}
                                            />
                                            {benefitType === 'Specify Benefit Types' && (
                                                <div className="mt-2">
                                                    <Select
                                                        isMulti
                                                        value={selectedBenefitType.map(type => ({ value: type, label: type }))}
                                                        onChange={(selectedOptions) =>
                                                            setSelectedBenefitType(selectedOptions.map(option => option.value))
                                                        }
                                                        options={[
                                                            { value: 'Medical', label: 'Medical' },
                                                            { value: 'Dental', label: 'Dental' },
                                                            { value: 'Vision', label: 'Vision' },
                                                            { value: 'EAP', label: 'EAP' },
                                                            { value: 'HRA', label: 'HRA' },
                                                            { value: 'FSA', label: 'FSA' },
                                                            { value: 'Other', label: 'Other' },
                                                        ]}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-12 text-center mb-3">
                                            <button disabled={isDisabled}
                                                type="button"
                                                className="btn btn-success btn-sm mt-1 me-1"
                                                onClick={editingContactId ? handleSaveContact : handleAddContact}
                                            >
                                                {editingContactId ? 'Update Contact' : 'Add Contact'}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-lg" disabled={isDisabled}
                                                // onClick={() => setShowForm(false)}
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}

                        <div className="container">
                            {contacts.length ? (
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Description</th>
                                            <th>Email</th>
                                            <th className="edit_contact">Carrier</th>
                                            <th className="edit_contact">Benefit Type</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contacts.map((contact, index) => (
                                            <tr key={index}>
                                                <td>{contact.contactDescription}</td>
                                                <td>{contact.contactEmail}</td>
                                                <td className="edit_contact">
                                                    {contact.carrierName ? contact.carrierName : contact.carrierType}
                                                </td>
                                                <td className="edit_contact">
                                                    {contact.benefitName ? contact.benefitName :contact.benefitType}
                                                </td>
                                                <td>
                                                    <div className="form-check form-switch form-toggle">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input form-check-input-toggle-active toggle-input-switch"
                                                            role="switch"
                                                            id={`contact_status_${contact.contactId}`}
                                                            checked={contact?.contactStatus === "Active"}
                                                            disabled={isDisabled}
                                                            onChange={(e) => handleToggleChange(e, contact.contactId)}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <button onClick={() => handleEditContact(contact)} disabled={isDisabled} title="Edit" style={{ border: 'none', backgroundColor: '#fff' }}>
                                                        ✏️
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <h3>No Contacts</h3>
                            )}
                        </div>

                       
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnrollmentContacts;
